import { Control } from 'js/components/common/Fields/Control';
import withField from 'js/components/common/Fields/withField';
import React, { useEffect, useState } from 'react';
import ValidationIcon from 'js/components/common/Fields/Icons/ValidationIcon';
import VisibilityIcon from 'js/components/common/Fields/Icons/VisibilityIcon';
import { InputShallow } from 'js/components/common/Fields/Input/components/InputShallow';
import { I18n } from 'js/components/common/I18n';

import style from './SwissInput.scss';

export const InputBare = ({
                              /* rff render props */
                              input,
                              meta,
                              /* user provided props */
                              name,
                              label,
                              hint,
                              type = 'text',
                              classNames,
                              onClick,
                              showPasswordEye = true,
                              fromComponent,
                              noValidate,
                              errorMessage,
                              notEmpty,
                              isLabelExist,
                              labelText,
                              errorAppeared,
                              ...inputDomProps
                          }) => {
    const { touched, error, submitting, valid, pristine } = meta;
    const showPasswordIcon = showPasswordEye && type === 'password';

    const tKey = isLabelExist ? labelText : `playtech.mobile.system.input.${fromComponent}.label`;
    const classControl = style.control;
    const [isVisible, setIsVisible] = useState(false);
    const [isAbove, setIsAbove] = useState(false);
    const [isFocused, setIsFocused] = useState(false);
    const classValidateInput = isFocused ? style.focus : error ? style.invalid : style.valid;
    const toggleVisible = () => setIsVisible(!isVisible);

    const clickOnInvalidIcon = (e) => {
        e.target.offsetParent.querySelector('input').focus();
    };

    const onInputFocus = (e) => {
        toggleLabel(e);
        setIsFocused(!isFocused);
        clickOnInvalidIcon(e);
    };

    const onBlur = (e) => {
        toggleLabel(e);
        setIsFocused(!isFocused);
    };

    const toggleLabel = (e) => {
        !e.target.value && setIsAbove(!isAbove);
    };

    useEffect(() => {
        if (submitting && input.name === 'promoCode' && !errorAppeared) {
            !input.value && pristine && setIsAbove(false);
        }
    }, [submitting, pristine, errorAppeared]);

    return (
        <Control {...{
            meta,
            classNames,
            onClick,
            label,
            name,
            hint,
            animate: true,
            isSwissControl: true,
            isFocused,
            noValidate,
            errorMessage,
            errorAppeared
        }}
                 className={`${isFocused && style.active} ${classValidateInput} ${classControl}`}
        >
            <fieldset onBlur={onBlur}>
                <InputShallow
                    {...input}
                    {...inputDomProps}
                    name={name}
                    type={isVisible ? 'text' : type}
                    {...submitting ? { disabled: true } : {}}
                    className={style.inputField}
                    onFocus={onInputFocus}

                />

                <I18n className={`${style.label} ${isAbove && style.labelAbove} ${!isFocused && !valid && style.labelInvalid}`} tKey={tKey} />
                {noValidate && !isFocused && (errorAppeared || notEmpty) && (
                    <ValidationIcon
                        className={`${classNames?.validationIcon} ${style.icon} ${errorAppeared && style.invalidIcon}`}
                        isValid={errorAppeared ? false : notEmpty}
                        animate={true}
                        onClick={clickOnInvalidIcon}
                    />
                )}
                {!noValidate && touched && !isFocused && (
                    <ValidationIcon
                        className={`${classNames?.validationIcon} ${style.icon}`}
                        isValid={!error}
                        animate={true}
                        onClick={clickOnInvalidIcon}
                    />
                )}

                {showPasswordIcon && (
                    <VisibilityIcon
                        onClick={toggleVisible}
                        isVisible={isVisible}
                    />
                )}
            </fieldset>

        </Control>
    );
};

export const SwissInput = withField(InputBare);
